import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useCallback, useState } from "react";
import { DatePicker } from "../../components/DatePicker";
import { useStyles } from "./styles";
import Stack from "@mui/material/Stack";
import { Search } from "@mui/icons-material";
import TabPanel from "../../components/TabPanel";
import { Overview } from "./Overview";
import { Campaign } from "./Campaign";
import { listRescueCampaign, listResults } from "../../services/results";
import { useQuery } from "react-query";
import { subMonths } from "date-fns";

export const Results = () => {
  const styles = useStyles();

  const [activeView, setActiveView] = useState<number>(0);
  const [startDate, setStartDate] = useState<Date>(subMonths(new Date(), 1));
  const [endDate, setEndDate] = useState<Date>(new Date());

  const results = useQuery("results", async () => {
    const response = await listResults(startDate, endDate);

    return response;
  });

  const rescue = useQuery("rescue", async () => {
    const response = await listRescueCampaign(startDate, endDate);

    return response;
  });

  const handleChangeView = useCallback((view: number) => {
    setActiveView(view);
  }, []);

  const handleRefetch = useCallback(() => {
    rescue.refetch();
    results.refetch();
  }, [rescue, results]);

  return (
    <>
      <Stack spacing={4}>
        <Stack className={styles.root}>
          <Typography variant="h4">
            Resultados dos disparos em canais digitais
          </Typography>
          <Typography variant="body2">
            Aqui fica todos os resultados que seus disparos em canais digitais
            tiveram.
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            <DatePicker
              fullWidth
              size="small"
              label="Data de início"
              value={startDate}
              onChange={(date) => setStartDate(date as Date)}
            />
            <DatePicker
              fullWidth
              size="small"
              label="Data de término"
              value={endDate}
              onChange={(date) => setEndDate(date as Date)}
            />
            <Button
              onClick={handleRefetch}
              fullWidth
              startIcon={<Search />}
              color="primary"
            >
              Buscar
            </Button>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            <Button
              onClick={() => handleChangeView(0)}
              variant={activeView === 0 ? "contained" : "outlined"}
            >
              Visão geral
            </Button>
            <Button
              onClick={() => handleChangeView(1)}
              variant={activeView === 1 ? "contained" : "outlined"}
            >
              Campanhas
            </Button>
          </Stack>
        </Stack>
        <TabPanel index={0} value={activeView}>
          <Overview
            overview={results.data?.visaoGeral[0]}
            day={results.data?.vendasDia}
            store={results.data?.vendasLoja}
            hours={results.data?.vendasHora}
            genre={results.data?.genero}
            ageGroup={results.data?.faixaEtaria}
            rescue={rescue.data?.detalhe}
            rescueDetail={rescue.data?.lista}
            loading={rescue.isFetching || results.isFetching}
          />
        </TabPanel>
        <TabPanel index={1} value={activeView}>
          <Campaign
            loading={results.isFetching}
            data={results.data?.campanhas}
          />
        </TabPanel>
      </Stack>
    </>
  );
};
